import * as React from "react"
import Hammer from "react-hammerjs"
import AvatarEditor from "react-avatar-editor"
import { classNames } from "../../utils"

interface IPictureEditorProps {
    pictureEditorElement: () => React.LegacyRef<AvatarEditor>
    imagePath: string
    zoomInButton: React.MutableRefObject<HTMLButtonElement>
    zoomOutButton: React.MutableRefObject<HTMLButtonElement>
    rotateLeftButton: React.MutableRefObject<HTMLButtonElement>
    rotateRightButton: React.MutableRefObject<HTMLButtonElement>
}

export const controls = {
    zoomIn: () => { },
    zoomOut: () => { },
    rotateLeft: () => { },
    rotateRight: () => { }
}

const PictureEditor: React.FC<IPictureEditorProps> = props => {
    const { imagePath, pictureEditorElement, zoomInButton, zoomOutButton, rotateLeftButton, rotateRightButton } = props

    const [scale, setScale] = React.useState(1)
    const [tempScale, setTempScale] = React.useState(1)
    const [imageSize, setImageSize] = React.useState({ width: 0, height: 0 })
    const [rotation, setRotation] = React.useState(0)

    const handlePinchStart: HammerListener = (event) => {
        setTempScale(scale)
    }

    const handlePinch: HammerListener = (event) => {
        let newScale = tempScale * event.scale
        if (newScale < 1) newScale = 1
        setScale(newScale)
    }

    const zoomIn = () => {
        let newScale = scale + 0.2
        if (newScale > 5) newScale = 5;
        setScale(newScale)
    }

    const zoomOut = () => {
        let newScale = scale - 0.2
        if (newScale < 1) newScale = 1;
        setScale(newScale)
    }

    const rotateLeft = () => {
        let newRotation = rotation - 90;
        if(newRotation === -360){
            newRotation = 0;
        }
        setRotation(newRotation)
    }

    const rotateRight = () => {
        let newRotation = rotation + 90;
        if(newRotation === 360){
            newRotation = 0;
        }
        setRotation(newRotation)
    }

    React.useEffect(() => {
        const image = new Image()
        image.src = imagePath
        image.onload = () => {
            let height = image.naturalHeight
            let width = image.naturalWidth
            if (height > width) {
                width = 600 * width / height
                height = 600
            } else {
                height = 600 * height / width
                width = 600
            }
            setImageSize({ width, height })
        }
        setScale(1)
        setRotation(0)

    }, [imagePath])

    const zoomInButtonElem = zoomInButton.current
    const zoomOutButtonElem = zoomOutButton.current
    const rotateLeftButtonElem = rotateLeftButton.current
    const rotateRightButtonElem = rotateRightButton.current
    React.useEffect(() => {
        if (zoomInButtonElem) zoomInButtonElem.addEventListener("click", zoomIn)
        if (zoomOutButtonElem) zoomOutButtonElem.addEventListener("click", zoomOut)
        if (rotateLeftButtonElem) rotateLeftButtonElem.addEventListener("click", rotateLeft)
        if (rotateRightButtonElem) rotateRightButtonElem.addEventListener("click", rotateRight)
        return () => {
            if (zoomInButtonElem) zoomInButtonElem.removeEventListener("click", zoomIn)
            if (zoomOutButtonElem) zoomOutButtonElem.removeEventListener("click", zoomOut)
            if (rotateLeftButtonElem) rotateLeftButtonElem.removeEventListener("click", rotateLeft)
            if (rotateRightButtonElem) rotateRightButtonElem.removeEventListener("click", rotateRight)
        }
        // eslint-disable-next-line
    }, [zoomInButtonElem, zoomOutButtonElem, rotateLeftButtonElem, rotateRightButtonElem, scale, rotation])

    return (<Hammer
        onPinchStart={handlePinchStart}
        onPinch={handlePinch}
        options={{
            domEvents: true,
            recognizers: {
                pinch: { enable: true }
            }
        }}
    >
        <div className={classNames({
            "avatar-wrapper": true,
            "avatar-wrapper--vertical": imageSize.height >= imageSize.width,
            "avatar-wrapper--horizontal": imageSize.height < imageSize.width
        })}>
            <AvatarEditor
                ref={pictureEditorElement()}
                image={imagePath}
                width={imageSize.width}
                height={imageSize.height}
                border={0}
                scale={scale}
                rotate={rotation}
                style={{
                    width: "100%",
                    height: "100%"
                }}
            />
        </div>
    </Hammer>)
}

export default PictureEditor